import { ArrowUpRight } from "lucide-react";
import { ProvioMapEmbed } from "@/components/site/ProvioMapEmbed";
import { samplingMapPageUrl } from "@/data/samplingMap";
import { useLang } from "@/i18n/LangContext";
import { cn } from "@/lib/utils";

type SamplingLocationsSectionProps = {
  className?: string;
  id?: string;
};

export const SamplingLocationsSection = ({
  className,
  id = "provtagningsstallen",
}: SamplingLocationsSectionProps) => {
  const { lang } = useLang();
  const sv = lang === "sv";

  const copy = sv
    ? {
        eyebrow: "Provio · Synlab · Unilabs",
        title: "Provtagning via vårt nätverk i Sverige",
        text: "Bor du inte i Göteborg? Du kan lämna prover på ett av de erbjudna provtagningsställena. Vilka ställen som går att använda beror på provtyp och analys. Följ remissen och våra instruktioner innan du går dit.",
        mapTitle: "Karta över erbjudna provtagningsställen",
        openMap: "Öppna kartan i en ny flik",
      }
    : {
        eyebrow: "Provio · Synlab · Unilabs",
        title: "Sample collection through our network in Sweden",
        text: "If you do not live in Gothenburg, you can provide samples at one of the offered collection locations. Available locations depend on the sample type and analyses required. Follow the referral and our instructions before visiting.",
        mapTitle: "Map of offered collection locations",
        openMap: "Open the map in a new tab",
      };

  return (
    <section id={id} className={cn("scroll-mt-24 py-14 lg:py-16", className)}>
      <div className="container-wide">
        <div className="mx-auto max-w-3xl">
          <span className="text-sm font-semibold uppercase tracking-wider text-primary">
            {copy.eyebrow}
          </span>
          <h2 className="mt-2 font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            {copy.title}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">{copy.text}</p>
        </div>
        <div className="mt-8">
          <ProvioMapEmbed title={copy.mapTitle} />
          <a
            href={samplingMapPageUrl}
            target="_blank"
            rel="noreferrer"
            className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:text-primary/80"
          >
            {copy.openMap}
            <ArrowUpRight className="h-4 w-4" aria-hidden />
          </a>
        </div>
      </div>
    </section>
  );
};
